import {DateUtils} from "../utils/date.utils";
import {injectable} from "inversify";

type MetaData = { eot?: number };
type StorageMetaData = Record<string, MetaData>;

@injectable()
export class StorageService {

    private STORAGE_META_KEY = 'fnsm';

    public setItem(key: string, value: any, eot?: 'session' | Date): void {
        value = JSON.stringify(value);

        if (eot === 'session') {
            sessionStorage.setItem(key, value);
        } else {
            this.updateStorageMetaData(key, eot);
            localStorage.setItem(key, value);
        }
    }

    public getItem(key: string): any {
        let rawValue = sessionStorage.getItem(key);

        if (!rawValue) {
            const metaData = this.getMetaDataByItemKey(key);
            if (metaData.eot && metaData.eot < DateUtils.now().getTime()) {
                this.removeItem(key);
                return null;
            }

            rawValue = localStorage.getItem(key);
        }

        return JSON.parse(rawValue);
    }

    public removeItem(key: string) {
        sessionStorage.removeItem(key);
        localStorage.removeItem(key);
        this.removeItemFromStorageMetaData(key);
    }

    private updateStorageMetaData(key: any, eot?: Date): void {
        if (eot) {
            const metaData = this.getStorageMetaData();
            metaData[key] = {eot: eot.getTime()};
            this.setStorageMetaData(metaData);
        }
    }

    private removeItemFromStorageMetaData(key): void {
        const metaData = this.getStorageMetaData();
        delete metaData[key];
        this.setStorageMetaData(metaData);
    }

    private getMetaDataByItemKey(key: string): MetaData {
        const metaData = this.getStorageMetaData();
        return metaData[key] || {};
    }

    private getStorageMetaData(): StorageMetaData {
        return JSON.parse(localStorage.getItem(this.STORAGE_META_KEY)) || {};
    }

    private setStorageMetaData(metaData: StorageMetaData): void {
        localStorage.setItem(this.STORAGE_META_KEY, JSON.stringify(metaData));
    }


}